import withAsyncRouteLoading from "UIComponents/AsyncRouteLoadingHoc";

export default store => ({
  path: "events",
  component: withAsyncRouteLoading(() =>
    import(
      /* webpackChunkName: "admissions-marketing-engagement" */ "Admissions/features/MarketingEngagement/components/Events"
    ).then(m => m.default)
  ),
});
